import React, { useState, useEffect, useRef } from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button,
    Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { getAccounts } from '../../API';
import AccountCard from './AccountCard';
import AccountSelectedTag from './AccountSelectedTag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle as farTimesCircle } from '@fortawesome/free-regular-svg-icons'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function AccountSelect(props) {
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [title, setTitle] = useState(props.multiple ? 'Select Accounts' : 'Select Account');
    const [searchOptions, setSearchOptions] = useState({ active: 1, ...props.searchOptions });
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    const [isLoading, setIsLoading] = useState(true);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    useEffect(() => {
        //fetchAccounts();
    }, []);

    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const defaultAccountCardOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: false,
            address: false,
            email: false,
            balance: true
        },
        actions: {
            view: false,
            eidt: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: true,
            cancel: false
        }
    };

    const accountCardOptions = { ...defaultAccountCardOptions, ...props.accountCardOptions}

    const search = async () => {
        setIsLoading(true);

        const searchAPIResults = await getAccounts(searchOptionsRef.current);
        setAccounts(searchAPIResults);

        setIsLoading(false);
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    const select = (account) => {
        if (props.multiple) {
            if (!selectedAccounts.some(o => o.accountID === account.accountID))
                setSelectedAccounts([...selectedAccounts, account]);
        } else {
            setSelectedAccounts([account]);
        }
    };

    const deselect = (accountId) => {
        setSelectedAccounts(selectedAccounts.filter(o => o.accountID !== accountId));
    };

    const selectAccounts = () => {
        props.toggle();
        setSearchOptions({ active: 1, ...props.searchOptions });
        props.select(props.multiple ? selectedAccounts : (selectedAccounts.length > 0 ? selectedAccounts[0] : null));
        setSelectedAccounts([]);
    };

    const cancel = () => {
        props.toggle();
        setSearchOptions({ active: 1, ...props.searchOptions });
        setSelectedAccounts([]);
    };

    const selectedList = selectedAccounts.map(so => {
        return (<AccountSelectedTag account={so} key={so.accountID} cancel={deselect} />);
    });

    const accountsList = isLoading ?
        (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
        : accounts.map(o => {
        return (<AccountCard account={o} key={o.accountID} select={select} deselect={deselect} selected={selectedAccounts.some(s => s.accountID === o.accountID)} options={accountCardOptions} />);
    });

    return (
        <Modal isOpen={props.open} toggle={props.toggle} size="xl">
            <ModalHeader>
                {title}
            </ModalHeader>
            <ModalBody>
                <div className="search">
                    <Row xs={1} md={2} lg={3} xl={3}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-check-square"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input type="select" name="active" value={searchOptions.active} onChange={updateSearch}>
                                        <option value={1}>Active</option>
                                        <option value={0}>Inactive</option>
                                        <option value={-1}>Any</option>
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-asterisk"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account Number" name="accountNumber" value={searchOptions.accountNumber || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Account" name="account" value={searchOptions.account || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="selected-list">
                    {selectedList}
                </div>
                <div className="record-list">
                    {accountsList}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="btn-icon" color="danr-red" onClick={cancel}><FontAwesomeIcon icon={farTimesCircle} /><span>Cancel</span></Button>
                <Button className="btn-icon" color="danr-green" onClick={selectAccounts}><FontAwesomeIcon icon={faCheckCircle} /><span>Select</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default AccountSelect;